import { useState, useEffect } from 'react';

// Detect a mobile viewport via matchMedia, kept in sync on resize/orientation
// change. Pass a custom media query to override the default breakpoint.
export default function useIsMobile(query = '(max-width: 768px)') {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    // addEventListener is the modern API; addListener is the legacy fallback
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
    } else {
      mql.addListener(handler);
    }
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', handler);
      } else {
        mql.removeListener(handler);
      }
    };
  }, [query]);

  return isMobile;
}
